import { pagesPath } from '@/lib/$path';

export const CommonChangeLoginFromOtherParams = {
  /**
   * 招待コード
   */
  invite_token: 'invite_token',
  /**
   * 紹介・掲載側の指定
   */
  use_type: 'use_type',
  /**
   * 代理ログイン・管理者ログインのtoken
   */
  token: 'token',
  /**
   * 代理ログイン・管理者ログインなどからのリダイレクト指定先
   */
  redirect: 'redirect',
  /**
   * 管理者ログインフラグ
   */
  is_admin: 'is_admin',
};

export const CommonRequestCardsSearchParams = {
  list_type: 'list_type',
  is_list_sideber: 'is_list_sideber',
  search_portal_patient_name: 'search_portal_patient_name',
  portal_patient_page: 'portal_patient_page',
  portal_patient_id: 'portal_patient_id',
  request_card_folder_id: 'request_card_folder_id',
  search_portal_office_name: 'search_portal_office_name',
  request_card_status: 'request_card_status',
  request_status: 'request_status',
  accept_status: 'accept_status',
  request_card_page: 'request_card_page',
  request_card_id: 'request_card_id',
  is_request_card_message: 'is_request_card_message',
  search_request_card_word: 'search_request_card_word',
  is_thanked: 'is_thanked',
};

export const CommonStationSearchParams = {
  searchTarget: 'searchTarget',
  searchType: 'searchType',
  postCode: 'postCode',
  prefName: 'prefName',
  address: 'address',
  partnerName: 'partnerName',
  isCalendarOr: 'isCalendarOr',
  calendars: 'calendars[]',
  movingMinutes: 'movingMinutes',
  searchFilters: 'searchFilters[]',
  sort: 'sort',
  patient_id: 'patient_id',
  page: 'page',
  isShowMap: 'isShowMap',
  isNoAddition: 'isNoAddition',
  medicalSubjects: 'medicalSubjects[]',
  mode: 'mode',
};

export const pathInfo = {
  /**
   * すべてのパスで指定可能なパラメータを管理
   */
  ['/*']: {
    searchParams: {
      ...CommonChangeLoginFromOtherParams,
      from_qr: 'from_qr',
    },
    localStorage: {
      /**
       * 検索対象を保存
       */
      searchTarget: 'searchTarget',
    },
  },
  [pagesPath.signup.$url().pathname]: {},
  [pagesPath.signin.$url().pathname]: {
    searchParams: {
      ...CommonChangeLoginFromOtherParams,
    },
  },
  [pagesPath.recept.register.portal_staff.$url().pathname]: {
    searchParams: {
      invite_token: 'invite_token',
    },
  },
  [pagesPath.recept.register.request_user.$url().pathname]: {
    searchParams: {
      invite_token: 'invite_token',
    },
  },
  [pagesPath.app.stations._portalOfficeId('').$url().pathname]: {
    searchParams: {
      patient_id: 'patient_id',
    },
    anchorLinkIds: {
      CurrentSchedule: 'CurrentSchedule',
    },
  },
  [pagesPath.app.$url().pathname]: {
    searchParams: {
      postCode: 'postCode',
      searchFilters: 'searchFilters[]',
      page: 'page',
      isNoAddition: 'isNoAddition',
    },
  },
  [pagesPath.app.stations.search.$url().pathname]: {
    searchParams: {
      ...CommonStationSearchParams,
    },
  },
  [pagesPath.public.stations.search.$url().pathname]: {
    searchParams: {
      ...CommonStationSearchParams,
    },
  },
  [pagesPath.app.patients.$url().pathname]: {
    searchParams: {
      is_accept: 'is_accept',
      is_alphabetical_order: 'is_alphabetical_order',
      search_patient_word: 'search_patient_word',
      patient_id: 'patient_id',
    },
  },
  [pagesPath.app.portal_patients.$url().pathname]: {
    searchParams: {
      page: 'page',
      list_type: 'list_type',
      is_list_sideber: 'is_list_sideber',
      search_portal_patient_name: 'search_portal_patient_name',
      expected_discharge_date_from: 'expected_discharge_date_from',
      expected_discharge_date_to: 'expected_discharge_date_to',
      nursing_care_levels: 'nursing_care_levels',
      is_accept: 'is_accept',
      sort: 'sort',
      portal_patient_id: 'portal_patient_id',
      portal_patient_detail_type: 'portal_patient_detail_type',
      is_save: 'is_save',
    },
  },
  [pagesPath.app.requests.$url().pathname]: {
    searchParams: {
      patient_id: 'patient_id',
      search_request_card_word: 'search_request_card_word',
      is_thanked: 'is_thanked',
      thanked: 'thanked',
      tab: 'tab',
    },
  },
  [pagesPath.app.requests.create._portalOfficeId('').$url().pathname]: {
    searchParams: {
      patient_id: 'patient_id',
    },
  },
  [pagesPath.app.requests._requestCardId('').edit.$url().pathname]: {
    searchParams: {
      list_type: 'list_type',
    },
  },
  [pagesPath.admin.requests.$url().pathname]: {
    searchParams: {
      patient_id: 'patient_id',
      search_request_card_word: 'search_request_card_word',
      is_thanked: 'is_thanked',
      thanked: 'thanked',
      tab: 'tab',
      request_status: 'request_status',
      accept_status: 'accept_status',
    },
  },
  [pagesPath.admin.request_cards.$url().pathname]: {
    searchParams: {
      ...CommonRequestCardsSearchParams,
    },
  },
  [pagesPath.app.request_cards.$url().pathname]: {
    searchParams: {
      ...CommonRequestCardsSearchParams,
    },
  },
  [pagesPath.app.mypage.organization.activity.$url().pathname]: {
    searchParams: {
      page: 'page',
    },
  },
  [pagesPath.admin.organization.activity.$url().pathname]: {
    searchParams: {
      page: 'page',
    },
  },
  IBOW_DOCUMENT_REQUEST: {
    searchParams: {
      /**
       * 介護事業所番号
       */
      officecode: 'officecode',
      /**
       * CST番号
       */
      cst: 'cst',
      /**
       * iBowID
       */
      ibowid: 'ibowid',
    },
  },
};
